import { input } from "@angular/core";

export const statusData = [
    {
      text: 'Reserviert',
      value: 'Reserviert',
      color: '#8C31D0'
    },
    {
      text: 'Gebucht',
      value: 'Gebucht',
      color: '#00a4a4'
      //color: '#e7e7e7ff'
    },
    {
      text: 'Abgesagt',
      value: 'Abgesagt',
      color: '#ffd700'
    },
    {
      text: 'Rechnung offen',
      value: 'Rechnung offen',
      color: '#FB00BC'
    },
    {
      text: 'Verplant',
      value: 'Verplant',
      color: '#727272'
    },
    //{
    //  text: 'Überprüft',
    //  value: 'Überprüft',
    //  color: '#ff2626'
    //},
    {
      text: 'Abgerechnet',
      value: 'Abgerechnet',
      color: '#26d947'
    },
  ];

export const typeData = [
  //EINSATZ
  {
    text: 'Einsatz', 
    value:'Einsatz',
    type: 'MISSIONEVENT',
    tab: 'MISSIONEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/hands-asl-interpreting.svg',
    exportName: 'einsatz',
    color: '#FF4D00',
  },

  //PRIVATEINTRAGUNG
  {
    text: 'Privat', 
    value:'Privat',
    type: 'PRIVATEEVENT',
    tab: 'PRIVATEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/snooze.svg',
    exportName: 'privateintragung',
    color: '#FF4D00',
  },
  {
    text: 'Homeoffice', 
    value:'Homeoffice',
    type: 'HOMEOFFICEHOURLYEVENT',
    tab: 'PRIVATEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/snooze.svg',
    exportName: 'privateintragung',
    color: '#FF4D00',
  },

  //ABWESENHEIT
  {
    text: 'Urlaub', 
    value: 'Urlaub',
    type: 'HOLIDAYEVENT',
    tab: 'ABSENCEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/island-tropical.svg',
    exportName: 'urlaub',
    color: '#FF4D00',
  },
  {
    text: 'Überstundenfrei', 
    value: 'Überstundenfrei',
    type: 'HOLIDAYEVENT',
    tab: 'ABSENCEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/island-tropical.svg',
    exportName: 'urlaub',
    color: '#FF4D00',
  },
  {
    text: 'Elternzeit', 
    value: 'Elternzeit',
    type: 'PARENTALLEAVE',
    tab: 'ABSENCEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/question.svg',
    exportName: 'question',
    color: '#FF4D00',
  },
    {
    text: 'Mutterschutz', 
    value: 'Mutterschutz',
    type: 'MATERNITYPROTECTION',
    tab: 'ABSENCEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/baby-carriage.svg',
    exportName: 'mutterschutz',
    color: '#FF4D00',
  },
  {
    text: 'Keine Termine', 
    value: 'Keine Termine',
    type: 'NOEVENTS',
    tab: 'ABSENCEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/calendar-circle-minus.svg',
    exportName: 'keinetermine',
    color: '#FF4D00',
  },
  {
    text: 'Feiertag', 
    value: 'Feiertag',
    type: 'HOLIDAY',
    tab: 'ABSENCEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/question.svg',
    exportName: 'question',
    color: '#FF4D00',
  },
  {
    text: 'Betriebsferien', 
    value: 'Betriebsferien',
    type: 'COMPANYHOLIDAY',
    tab: 'ABSENCEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/question.svg',
    exportName: 'question',
    color: '#FF4D00',
  },
  {
    text: 'Krank', 
    value: 'Krank',
    type: 'SICKEVENT',
    tab: 'ABSENCEEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/capsule.svg',
    exportName: 'krank',
    color: '#FF4D00',
  },

  //ARBEIT UND VERTRETUNG
  {
    text: 'Homeoffice', 
    value:'Homeoffice',
    type: 'HOMEOFFICEEVENT',
    tab: 'WORKREPRESENTATIONEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/question.svg',
    exportName: 'question',
    color: '#FF4D00',
  },
  {
    text: 'Berufseinstiegsphase', 
    value:'Berufseinstiegsphase',
    type: 'CAREERENTRYEVENT',
    tab: 'WORKREPRESENTATIONEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/question.svg',
    exportName: 'question',
    color: '#FF4D00',
  },
  {
    text: '1. Krankheitsvertretung', 
    value:'1. Krankheitsvertretung',
    type: 'ILLNESSREPRESENTATIONEVENT',
    tab: 'WORKREPRESENTATIONEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/repeat-1.svg',
    exportName: 'krankheitsvertretung',
    color: '#FF4D00',
  },
  {
    text: '2. Krankheitsvertretung', 
    value:'2. Krankheitsvertretung',
    type: 'ILLNESSREPRESENTATIONEVENT',
    tab: 'WORKREPRESENTATIONEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/repeat-1.svg',
    exportName: 'krankheitsvertretung',
    color: '#FF4D00',
  },
  {
    text: 'Krankheitsvertretung für Termin', 
    value:'Krankheitsvertretung für Termin',
    type: 'ILLNESSREPRESENTATIONFLEX',
    tab: 'WORKREPRESENTATIONEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/repeat-1.svg',
    exportName: 'krankheitsvertretung',
    color: '#FF4D00',
  },

  //TEAMEVENT
  {
    text: 'Teamevent', 
    value:'Teamevent',
    type: 'TEAMEVENT',
    tab: 'TEAMEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/party-horn.svg',
    exportName: 'event',
    color: '#FF4D00',
  },

  //BESPRECHUNG
  {
    text: 'Besprechung', 
    value:'Besprechung',
    type: 'MEETINGEVENT',
    tab: 'MEETINGEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/handshake.svg',
    exportName: 'besprechung',
    color: '#FF4D00',
  },

  //BLOCKER UND MEHR
  {
    text: 'Arzt-Termin-Blocker', 
    value:'Arzt-Termin-Blocker',
    type: 'MEDICALBLOCKEREVENT',
    tab: 'BLOCKERMOREEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/question.svg',
    exportName: 'question',
    color: '#FF4D00',
  },
  {
    text: 'Studentenblocker', 
    value:'Studentenblocker',
    type: 'STUDENTBLOCKEREVENT',
    tab: 'BLOCKERMOREEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/question.svg',
    exportName: 'question',
    color: '#FF4D00',
  },
  {
    text: 'Flex. Blocker', 
    value:'Flex. Blocker',
    type: 'FLEXBLOCKEREVENT',
    tab: 'BLOCKERMOREEVENT',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/question.svg',
    exportName: 'question',
    color: '#FF4D00',
  }
];
  
//export const typeData = [
//    {
//      text: 'Einsatz',
//      value: 'MISSIONEVENT',
//      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/hands-asl-interpreting.svg',
//      exportName: 'einsatz'
//    },
//    {
//      text: 'Privateintragung',
//      value: 'PRIVATEEVENT',
//      color: '#FF4D00',
//      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/snooze.svg',
//      exportName: 'privateintragung'
//    },
//    {
//      text: 'Krankheitsvertretung',
//      value: 'ILLNESSREPRESENTATIONEVENT',
//      color: '#1FFF00',
//      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/repeat-1.svg',
//      exportName: 'krankheitsvertretung'
//    },
//    {
//      text: 'Urlaub / Überstundenfrei',
//      value: 'HOLIDAYEVENT',
//      color: '#0022FF',
//      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/island-tropical.svg',
//      exportName: 'urlaub'
//    },
//    {
//      text: 'Event',
//      value: 'TEAMEVENT',
//      color: '#FF00C5',
//      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/party-horn.svg',
//      exportName: 'event'
//    },
//    {
//      text: 'Besprechung',
//      value: 'MEETINGEVENT',
//      color: '#00FFEB',
//      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/handshake.svg',
//      exportName: 'besprechung'
//    },
//    {
//      text: 'Nicht abrechenbar',
//      value: 'NOTBILLABLEEVENT',
//      color: '#6700FF',
//      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/not-equal.svg',
//      exportName: 'nichtabrechenbar'
//    },
//    {
//      text: 'Krank',
//      value: 'SICKEVENT',
//      color: '#6700FF',
//      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/capsule.svg',
//      exportName: 'krank'
//    },
//  ];

export const categoryData = [
    {
      text: 'Arzttermin',
      value: 'Arzttermin',
      color: '#2e8b57',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/stethoscope.svg',
      exportName: 'arzttermin'
    },
    {
      text: 'Arbeitsleben',
      value: 'Arbeitsleben',
      color: '#a0522d',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/briefcase.svg',
      exportName: 'arbeitsleben'
    },
    {
      text: 'Schule',
      value: 'Schule',
      color: '#87ceeb',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/school-flag.svg',
      exportName: 'schule'
    },
    {
      text: 'Universität',
      value: 'Universität',
      color: '#87ceeb',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/graduation-cap.svg',
      exportName: 'universität'
    },
    {
      text: 'Veranstaltungen',
      value: 'Veranstaltungen',
      color: '#6a5acd',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/keynote.svg',
      exportName: 'veranstaltungen'
    },
    {
      text: 'Gericht',
      value: 'Gericht',
      color: '#4682b4',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/gavel.svg',
      exportName: 'gericht'
    },
    {
      text: 'Ämter',
      value: 'Ämter',
      color: '#40e0d0',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/chair-office.svg',
      exportName: 'ämter'
    },
    {
      text: 'Privat',
      value: 'Privat',
      color: '#ff33b5',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/people-pants-simple.svg',
      exportName: 'privat'
    },
    {
      text: 'Telefondolmetschen',
      value: 'Telefondolmetschen',
      color: '#ff33b5',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/user-headset.svg',
      exportName: 'telefondolmetschen'
    },
    {
      text: 'Elternabende',
      value: 'Elternabende',
      color: '#ff33b5',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/family-pants.svg',
      exportName: 'elternabende'
    },
    {
      text: 'Aufnahmen',
      value: 'Aufnahmen',
      color: '#ff33b5',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/camera-movie.svg',
      exportName: 'aufnahmen'
    },
    {
      text: 'Religion',
      value: 'Religion',
      color: '#ff33b5',
      icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/cross.svg',
      exportName: 'religion'
    },
    
  ];


  export const eventFilterData = [

    //KATEGORIEN BEI EINSÄTZEN
    {
      text: 'Ohne Kategorie',
      value: null as any,
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Arzttermin',
      value: 'Arzttermin',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Arbeitsleben',
      value: 'Arbeitsleben',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Schule',
      value: 'Schule',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Universität',
      value: 'Universität',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Veranstaltungen',
      value: 'Veranstaltungen',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Gericht',
      value: 'Gericht',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Ämter',
      value: 'Ämter',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Privat',
      value: 'Privat',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Telefondolmetschen',
      value: 'Telefondolmetschen',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Elternabende',
      value: 'Elternabende',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Aufnahmen',
      value: 'Aufnahmen',
      group: 'Einsätze (Kategorie)',
    },
    {
      text: 'Religion',
      value: 'Religion',
      group: 'Einsätze (Kategorie)',
    },

    //STATUS BEI EINSÄTZEN
    {
      text: 'Reserviert',
      value: 'Reserviert',
      group: 'Einsätze (Status)',
    },
    {
      text: 'Gebucht',
      value: 'Gebucht',
      group: 'Einsätze (Status)',
    },
    {
      text: 'Abgesagt',
      value: 'Abgesagt',
      group: 'Einsätze (Status)',
    },
    {
      text: 'Rechnung offen',
      value: 'Rechnung offen',
      group: 'Einsätze (Status)',
    },
    {
      text: 'Abgerechnet',
      value: 'Abgerechnet',
      group: 'Einsätze (Status)',
    },
    {
      text: 'Verplant',
      value: 'Verplant',
      group: 'Einsätze (Status)',
    },

    //TYPEN
    {
      text: 'Privateintragung',
      value: 'PRIVATEEVENT',
      group: 'Typ',
    },
    {
      text: 'Homeoffice',
      value: 'HOMEOFFICEHOURLYEVENT',
      group: 'Typ',
    },
    {
      text: 'Krankheitsvertretung',
      value: 'ILLNESSREPRESENTATIONEVENT',
      group: 'Typ',
    },
    {
      text: 'Urlaub/Überstundenfrei',
      value: 'HOLIDAYEVENT',
      group: 'Typ',
    },
    {
      text: 'Elternzeit',
      value: 'PARENTALLEAVE',
      group: 'Typ',
    },
    {
      text: 'Mutterschutz',
      value: 'MATERNITYPROTECTION',
      group: 'Typ',
    },
    {
      text: 'Keine Termine',
      value: 'NOEVENTS',
      group: 'Typ',
    },
    {
      text: 'Feiertag',
      value: 'HOLIDAY',
      group: 'Typ',
    },
    {
      text: 'Betriebsferien',
      value: 'COMPANYHOLIDAY',
      group: 'Typ',
    },
    {
      text: 'Berufseinstiegsphase',
      value: 'CAREERENTRYEVENT',
      group: 'Typ',
    },
    {
      text: 'Arzt-Termin-Blocker',
      value: 'MEDICALBLOCKEREVENT',
      group: 'Typ',
    },
    {
      text: 'Studentenblocker',
      value: 'STUDENTBLOCKEREVENT',
      group: 'Typ',
    },
    {
      text: 'Team-Event',
      value: 'TEAMEVENT',
      group: 'Typ',
    },
    {
      text: 'Besprechung',
      value: 'MEETINGEVENT',
      group: 'Typ',
    },
    {
      text: 'Nicht abrechenbar',
      value: 'NOTBILLABLEEVENT',
      group: 'Typ',
    },
    {
      text: 'Krank',
      value: 'SICKEVENT',
      group: 'Typ',
    },
  ];

  
export const operatingTimeData = [
    {
      text: 'Feste Einsatzzeit',
      value: 'Feste Einsatzzeit',
    },
    {
      text: 'Flexible Einsatzzeit',
      value: 'Flexible Einsatzzeit',
    },
];

export const taskType = [
  {
    text: 'Besprechung',
    value: 'MEETINGEVENT',
  },
  {
    text: 'Kunden Termin',
    value: 'MISSIONEVENT',
  },
  {
    text: 'Krankheitsvertretung',
    value: 'ILLNESSREPRESENTATIONEVENT',
  },
  {
    text: 'nicht abrechnbar',
    value: 'NOTBILLABLEEVENT',
  },
  {
    text: 'Privat Termin',
    value: 'PRIVATEEVENT',
  },
  {
    text: 'Team Event',
    value: 'TEAMEVENT',
  },
  {
    text: 'Urlaub',
    value: 'HOLIDAYEVENT',
  },
]

export const subtypes = [
  {
    text: 'Übung',
    value: 1
  },  
  {
    text: 'Entwicklungszeit',
    value: 2
  },
  {
    text: 'Keiner',
    value: -1
  },
]

export const teamData = [
  {
    text: 'Team Türkis',
    value: 'teamTuerkis',
    id: 1
  },  
  {
    text: 'Team Blau',
    value: 'teamBlau',
    id: 2
  },
  {
    text: 'Team Grün',
    value: 'teamGruen',
    id: 3
  },
  {
    text: 'Team Orange',
    value: 'teamOrange',
    id: 4
  },
]

export const teamDataAll = [
  {
    text: 'Alle Teams',
    value: 'teamAll'
  },  
  {
    text: 'Team Türkis',
    value: 'teamTuerkis'
  },  
  {
    text: 'Team Blau',
    value: 'teamBlau'
  },
  {
    text: 'Team Grün',
    value: 'teamGruen'
  },
  {
    text: 'Team Orange',
    value: 'teamOrange'
  },
  {
    text: 'Praktikanten',
    value: 'trainee'
  },
]

export const stammteamData = [
  {
    text: 'Team Türkis',
    value: 1,
  },  
  {
    text: 'Team Blau',
    value: 2,
  },
  {
    text: 'Team Grün',
    value: 3,
  },
  {
    text: 'Team Orange',
    value: 4,
  },
]

export const specialInfoData = [
  {
    title: 'm',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/mars.svg',
    icon_name: 'mars',
    input: false,
    type: 'radio',
    value: 'm',
    name: 'männlich',
    exportName: 'mars'
  },  
  {
    title: 'w',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/venus.svg',
    icon_name: 'venus',
    input: false,
    type: 'radio',
    value: 'w',
    name: 'weiblich',
    exportName: 'venus'
  },
  {
    title: 'd',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/mars-and-venus.svg',
    icon_name: 'mars-and-venus',
    input: false,
    type: 'radio',
    value: 'd',
    name: 'divers',
    exportName: 'marsandvenus'
  }, 
  {
    title: 'Wichtig',
    label: 'wichtig',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/circle-info.svg',
    icon_name: 'circle-info',
    input: false,
    checked: false,
    type: 'checkbox',
    name: 'Wichtig',
    exportName: 'circleInfo'
  },  
  {
    title: 'Dolmetscher gewünscht',
    label: 'gewünscht',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/circle-plus.svg',
    icon_name: 'circle-plus',
    input: true,
    info: '',
    checked: false,
    type: 'checkbox',
    name: 'Dolmetscher gewünscht',
    exportName: 'circlePlus'
  },  
  {
    title: 'Dolmetscher ungewünscht',
    label: 'ungewünscht',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/circle-minus.svg',
    icon_name: 'circle-minus',
    input: true,
    info: '',
    checked: false,
    type: 'checkbox',
    name: 'Dolmetscher gewünscht',
    exportName: 'circleMinus'
  },  
  {
    title: 'feste Dolmetscher',
    label: 'fest',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/user-circle-plus.svg',
    icon_name: 'user-circle-plus',
    input: true,
    info: '',
    checked: false,
    type: 'checkbox',
    name: 'feste Dolmetscher',
    exportName: 'userCirclePlus'
  },  
  {
    title: 'angemeldete Dolmetscher',
    label: 'angemeldet',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/registered.svg',
    icon_name: 'registered',
    input: false,
    checked: false,
    type: 'checkbox',
    name: 'angemeldete Dolmetscher',
    exportName: 'registered'
  },  
  {
    title: 'genannte Dolmetscher',
    label: 'genannt',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/circle-dollar.svg',
    icon_name: 'circle-dollar',
    input: false,
    checked: false,
    type: 'checkbox',
    name: 'genannte DOlmetscher',
    exportName: 'circleDollar'
  },  
  {
    title: 'Social Media Video',
    label: 'Social Media',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/camera.svg',
    icon_name: 'camera',
    input: false,
    checked: false,
    type: 'checkbox',
    name: 'Social Media Video',
    exportName: 'camera'
  },  
   {
    title: 'Fremd Dolmetscher',
    label: 'Fremd Dolmetscher',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/circle-f.svg',
    icon_name: 'fremd Dolmetscher',
    input: false,
    checked: false,
    type: 'switch',
    name: 'Fremd Dolmetscher',
    exportName: 'circleF',
    options: [
      { name: '', info: '' },
    ]
  },  
  {
    title: 'Sprachlevel',
    label: 'Sprachlevel',
    icon: 'https://assets.tridimo.de/fontawesome/svgs/regular/globe.svg',
    icon_name: 'globe',
    input: true,
    type: 'select',
    value: '',
    name: 'Sprachlevel Englisch',
    exportName: 'globe',
    options: [
      { text: 'E1', value: 'E1' },
      { text: 'E2', value: 'E2' },
      { text: 'E3', value: 'E3' },
      { text: 'E4', value: 'E4' },
      { text: 'E5', value: 'E5' },
      { text: 'E?', value: 'E?' },
    ]
  }
]

export const platformIcons: Record<string, string> = {
  msteams: 'assets/icons/platform_icons/msteams.png',
  zoom: 'assets/icons/platform_icons/zoom.png',
  webex: 'assets/icons/platform_icons/webex.png',
  gotomeeting: 'assets/icons/platform_icons/gotomeeting.png',
  verbavoice: 'assets/icons/platform_icons/verbavoice.png',
  videotaxi: 'assets/icons/platform_icons/videotaxi.png',
  bigbluebutton: 'assets/icons/platform_icons/bigbluebutton.svg',
  online: 'assets/icons/platform_icons/online.png',
  apple: 'assets/icons/platform_icons/fbc.png',
  sonstiges: 'assets/icons/platform_icons/other.png',
};

export const platformOptions = [
  {text:'VerbaVoice', value:'verbavoice'},
  {text:'Videotaxi', value:'videotaxi'},
  {text:'BigblueButton', value:'bigbluebutton'},
  {text:'Apple', value:'apple'},
  {text:'Gotomeeting', value:'gotomeeting'},
  {text:'MS Teams', value:'msteams'},
  {text:'Online', value:'online'},
  {text:'Sonstiges', value:'sonstiges'},
  {text:'Webex', value:'webex'},
  {text:'Zoom', value:'zoom'},
]

export const billingType = [
  {
    text: 'Einzelabrechnung', 
    value:'Einzelabrechnung'
  },
  {
    text: 'Sammelrechnung', 
    value:'Sammelrechnung'
  },
  {
    text: 'Keine Abrechnugsart', 
    value:''
  },
]

export const fremdCoBilling = [
  {
    text: 'Tridimo', 
    value:'Tridimo'
  },
  {
    text: 'Kostentraeger', 
    value:'Kostentraeger'
  },
  {
    text: 'Keine Abrechnung', 
    value:''
  },
]

export const confirmationformData = [
  {
    text: 'Arztbestätigung', 
    value:'Arztbestätigung'
  },
  {
    text: 'Einzelbestätigung', 
    value:'Einzelbestätigung'
  },
  {
    text: 'Sammelbestätigung', 
    value:'Sammelbestätigung'
  },
  {
    text: 'LWL', 
    value:'lwl'
  },
  {
    text: 'SIKA', 
    value:'sika'
  },
  {
    text: 'Gerichtbestätigung', 
    value:'Gerichtbestätigung'
  },
  {
    text: 'Keine Bestätigung', 
    value:''
  },
]

export const sidebarData = [
  { text: 'Strg + Q', value: 'ctrl+q', key: 'q', ctrl: true, shift: false, alt: false },
  { text: 'Strg + Y', value: 'ctrl+y', key: 'y', ctrl: true, shift: false, alt: false },
];

export const allDayEventTypes = [
  "ILLNESSREPRESENTATIONEVENT", 
  "HOLIDAYEVENT", 
  "SICKEVENT", 
  "PARENTALLEAVE", 
  "MATERNITYPROTECTION", 
  "NOEVENTS", 
  "ABSENCEEVENT", 
  "COMPANYHOLIDAY", 
  "HOMEOFFICEEVENT", 
  "CAREERENTRYEVENT", 
  "MEDICALBLOCKEREVENT", 
  "STUDENTBLOCKEREVENT"
];